import React, { useEffect, useState } from "react";
import { Table } from "antd";
import { BiEdit } from "react-icons/bi";
import { AiFillDelete } from "react-icons/ai";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import CustomModal from "../components/CustomModal";

import {
  getProjects,
  deleteAProject,
  resetState,
} from "../features/project/projectSlice";

/* ===================== TABLE COLUMNS ===================== */
const columns = [
  {
    title: "SNo",
    dataIndex: "key",
    width: 70,
  },
  {
    title: "Media",
    dataIndex: "media",
    width: 100,
  },
  {
    title: "Title",
    dataIndex: "title",
    sorter: (a, b) => a.title.length - b.title.length,
  },
  {
    title: "Industry",
    dataIndex: "industry",
  },
  {
    title: "Tag",
    dataIndex: "tag",
  },
  {
    title: "Action",
    dataIndex: "action",
    width: 120,
  },
];

/* ===================== COMPONENT ===================== */
const ProjectsList = () => {
  const [open, setOpen] = useState(false);
  const [projectSlug, setProjectSlug] = useState("");

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(resetState());
    dispatch(getProjects());
  }, [dispatch]);

  const projectState = useSelector((state) => state.project.projects);

  const showModal = (slug) => {
    setOpen(true);
    setProjectSlug(slug);
  };

  const hideModal = () => {
    setOpen(false);
  };

  /* ===================== TABLE DATA ===================== */
const dataSource = projectState?.map((project, index) => {
  const isVideo = project.type === "video";

  const imageUrl = project.images?.[0]?.url;
  const videoUrl = project.video?.url;

  return {
    key: index + 1,

    media: isVideo && videoUrl ? (
      <video
        src={videoUrl}
        width={60}
        height={40}
        muted
        preload="metadata"
        style={{ objectFit: "cover", borderRadius: 4 }}
      />
    ) : imageUrl ? (
      <img
        src={imageUrl}
        alt={project.title}
        style={{
          width: 60,
          height: 40,
          objectFit: "cover",
          borderRadius: 4,
        }}
      />
    ) : (
      <span style={{ fontSize: 12, color: "#999" }}>No media</span>
    ),

    title: project.title,
    industry: project.industry,
    tag:  project.tag,

    action: (
      <>
        <Link
          to={`/admin/add-project/${project.slug}`}
          className="fs-4 text-danger"
        >
          <BiEdit />
        </Link>

        <button
          className="ms-3 fs-4 text-danger bg-transparent border-0"
          onClick={() => showModal(project.slug)}
        >
          <AiFillDelete />
        </button>
      </>
    ),
  };
});

  /* ===================== DELETE ===================== */
  const deleteProject = (slug) => {
    dispatch(deleteAProject(slug));
    setOpen(false);

    setTimeout(() => {
      dispatch(getProjects());
    }, 200);
  };

  return (
    <div>
      <h3 className="mb-4 title">Projects</h3>

      <Table
        columns={columns}
        dataSource={dataSource}
        pagination={{ pageSize: 8 }}
      />

      <CustomModal
        hideModal={hideModal}
        open={open}
        performAction={() => deleteProject(projectSlug)}
        title="Are you sure you want to delete this project?"
      />
    </div>
  );
};

export default ProjectsList;
